import React from "react";
import ReactLenis from "lenis/react";

const SmoothScroll = ({ children }) => (
  <ReactLenis root options={{ lerp: 0.09, duration: 1.4, smoothWheel: true, smoothTouch: false }}>
    {children}
  </ReactLenis>
);

export default SmoothScroll;
